require('../../modules/es7.array.includes');
module.exports = require('../../modules/_core').Array.includes;



// WEBPACK FOOTER //
// ../node_modules/react-jsonschema-form/node_modules/core-js/library/fn/array/includes.js